import { createLocaleManager } from '@previo/core'

const crmLocaleManager = createLocaleManager({ reloadOnChange: true })

export { crmLocaleManager }
